import { Injectable } from "@angular/core";
import { FilterSet } from "src/app/core/interfaces/filter-interface";
import { JobResultInterface, JobSearchInterface, JobSearchLightInterface } from "src/app/core/interfaces/job-card-interface";
import { Pagination } from "src/app/core/interfaces/pagination";
import { BackendService } from "src/app/core/services/backend-service";

@Injectable({
  providedIn: "root",
})
export class JobService extends BackendService {
  getJobsList(selectedFilters: FilterSet[], locationSearchValue: string | null, currentPagination: Pagination, useCustomProperties: boolean = false): Promise<JobResultInterface> {

    const jobSearchData: JobSearchInterface = {
      selectedFilters: selectedFilters,
      locationSearchValue: locationSearchValue,
      pagination: currentPagination,
      useCustomProperties: useCustomProperties
    }

    return this.post<JobSearchInterface, JobResultInterface>(
      "api/mobility-jobs",
      jobSearchData
    );
  }

  getJobsListForJourney(jobSearchLight: JobSearchLightInterface): Promise<JobResultInterface> {
    return this.post<JobSearchLightInterface, JobResultInterface>(
      "api/mobility-jobs/journey",
      jobSearchLight
    );
  }
}
